import script from "./ContextNav.vue?vue&type=script&setup=true&lang=js"
export * from "./ContextNav.vue?vue&type=script&setup=true&lang=js"

import "./ContextNav.vue?vue&type=style&index=0&id=45bbedcc&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45bbedcc"]])

export default __exports__